module.exports = __webpack_public_path__ + "static/media/updated_manage_users.88f17359.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/updated_manage_users.svg
// module id = 2724
// module chunks = 0